import TemplatingCodeEditor from './TemplatingCodeEditor';
import tags from './Tags/index';

export default TemplatingCodeEditor;
export { tags };
